import { CircleSpinnerOverlay } from "react-spinner-overlay";
import ParentData from "../../components/ParentData";
import ChildrenData from "../../components/ChildrenData";
import CommonAdvantages from "../../components/CommonAdvantages";
import Wishes from "../../components/Wishes";
import { useContext, useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { RegisterContext } from "../../contexts/RegisterContext";
import { WishValidatorContext } from "../../contexts/WishValidatorContext";
import { AddressContext } from "../../contexts/AddressContext";
import { editFreeAddressTextApplication, editMunicipalityApplication, getApplication } from "../services/applicationService";
import { MunicipalityRegisterBodyFormat, StringToDate } from "../../utils/RegisterApplicationBodyFormatter";
import { EgnValid } from '../../utils/EgnValidator';
import { SedGroupsCodes } from "../../Shared/statuses";
import Swal from 'sweetalert2';
import { validateDublicateChildrenNames, validateLnchYearsFromSelectedDate, validateTwin, validateWishes } from "../../utils/Validations";
import bcrypt from "bcryptjs-react";
import * as fileService from '../services/fileService'
import { ParameterContext } from "../../contexts/ParameterContext";
import { AuthContext } from "../../contexts/AuthContext";


export const EditMunicipalityRegisterForm = () => {
    const cyrillicRegex = /^(?!\s)(?:[\u0400-\u04FF0-9-]|\s(?!\s))*[\u0400-\u04FF0-9-] ?$/;
    const cyrillicAddressesRegex = /^(?!\s)(?:[\u0400-\u04FF0-9-.]|\s(?!\s))*[\u0400-\u04FF0-9-.]?$/;
    const phoneRegex = /^\d+$/;

    const roles = ['Admin', 'SuperAdmin', 'Municipality'];

    const parentDataRef = useRef(null);
    const childrenDataRef = useRef(null);
    const commonAdvantagesRef = useRef(null);
    const wishesRef = useRef(null);
    const additionalRef = useRef(null);

    const { isFormValid, toggleFormToValid, toggleFormToInvalid, commonAdvantages, advantages, sedentaryGroups, schools } = useContext(RegisterContext);
    const { validateSiblingEGN, removeError } = useContext(WishValidatorContext);
    const { validateSibling, isChildHavePreparatoryGroup, cleanChildHavePreparatoryGroupState, addressResidence, dontHaveCompletedGroup, siblingIsValid, validateAddressResidenceByEgn } = useContext(AddressContext);
    const { parameters } = useContext(ParameterContext);
    const { user } = useContext(AuthContext);
    const { regId } = useParams();

    let priemYear;
    let maxDesires;
    let autoTimeLived;
    let dirDisableChildData;

    if (parameters && parameters.nomParameters) {
        const parameterPriemYear = parameters.nomParameters.find(x => x.param_name == 'PRIEM_YEAR');
        const maxDesiresParam = parameters.nomParameters.find(x => x.param_name == 'DESIRE_MAX');

        const autoTimeLivedParam = parameters.nomParameters.find(x => x.param_name == 'AUTOMATIC_TIME_LIVED');
        const dirDisableChildDataParam = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'DIR_DISABLE_CIHLD_DATA');

        dirDisableChildData = dirDisableChildDataParam ? dirDisableChildDataParam.value : 2;
        maxDesires = maxDesiresParam ? maxDesiresParam.value : 10;

        priemYear = parameterPriemYear ? parameterPriemYear.value : new Date().getFullYear()
        autoTimeLived = autoTimeLivedParam ? autoTimeLivedParam.value : 0;
    } else {
        priemYear = new Date().getFullYear();
    }

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        twins: [],
        wishes: [],
        schools
    })
    const [isEditSuccessfully, setIsEditSuccessfully] = useState(false);

    document.title = `Редакция на заявление`;

    useEffect(() => {
        setLoading(true)
        if (schools.length > 0) {
            setFormData(state => ({
                ...state,
                schools: schools
            }))

            getApplication(regId, null)
                .then((data) => {
                    setTimeout(() => {
                        validateAddressResidenceByEgn(data.child.chilD_EGN);
                    }, 1000);

                    setFormData(state => ({
                        ...state,
                        regId: regId,
                        parentIsEgn: data.parent && data.parent.iS_LNC_P ? '0' : '1',
                        parentEgn: data.parent && data.parent.parenT_EGN,
                        parentName: data.parent && data.parent.parenT_NAME,
                        parentPhone: data.parent && data.parent.parenT_PHONE,
                        parentEmail: data.parent && data.parent.parenT_EMAIL,
                        childIsEgn: data.child && data.child.iS_LNC_C ? '0' : '1',
                        childEgn: data.child && data.child.chilD_EGN,
                        childLnchDate: data.child && StringToDate(data.child.datE_R),
                        childName: data.child && data.child.chilD_NAME,
                        currentAddress: data.regNumber.addresS_C_TXT,
                        currentAddressDate: StringToDate(data.regNumber.addresS_C_RESIDENCE_DATE),
                        permanentAddress: data.regNumber.addresS_P_TXT,
                        permanentAddressDate: StringToDate(data.regNumber.addresS_P_RESIDENCE_DATE),
                        dontHavePermanentAddress: data.regNumber.addresS_P_TXT && !data.regNumber.addresS_P_RESIDENCE_DATE && true,
                        dontHaveCurrentAddress: data.regNumber.addresS_C_TXT && !data.regNumber.addresS_C_RESIDENCE_DATE && true,
                        twins: data.twins ? data.twins.map((twin, index) => ({
                            twinNumber: index + 1,
                            twinIsEgn: EgnValid(twin.chilD_EGN) ? '1' : '0',
                            twinEgn: twin.chilD_EGN,
                            twinName: twin.chilD_NAME,
                            twinLncDate: StringToDate(twin.datE_R)
                        })) : [],
                        commonAdvantages: data.commonAdvatages && data.commonAdvatages.reduce((acc, x) => {
                            acc[x.code] = data.desires[0][x.code.toLowerCase()] ? true : false;
                            return acc;
                        }, {}),
                        wishes: data.desires && data.desires.map((desire, i) => {
                            let wish = {};
                            data.advatages.forEach(x => {
                                if (x.code == 'K100') {
                                    wish['K100_EGN'] = desire['k100_EGN'] == null ? "" : desire['k100_EGN'];
                                    wish['K100_NAME'] = desire['k100_NAME'] == null ? "" : desire['k100_NAME'];
                                    wish['K100_IsEgn'] = EgnValid(desire['k100_EGN']) || desire['k100_EGN'] == '' ? '1' : '0';
                                } else if (x.code == 'K200') {
                                    wish['K200_EGN'] = desire['k200_EGN'] == null ? "" : desire['k200_EGN'];
                                    wish['K200_NAME'] = desire['k200_NAME'] == null ? "" : desire['k200_NAME'];
                                    wish['K200_IsEgn'] = EgnValid(desire['k200_EGN']) || desire['k100_EGN'] == '' ? '1' : '0';
                                } else {
                                    wish[x.code] = desire[x.code.toLowerCase()] ? true : false;
                                }

                            })
                            wish.id = i;
                            wish.sedGroup = sedentaryGroups.find(x => x.code == SedGroupsCodes[`${desire.grupA_RESIDENCE}`]);
                            wish.school = schools.find(x => x.id == desire.dZ_ID)

                            return wish;
                        }),
                    }));
                    //console.log(data)
                    setLoading(false)
                })
        }

    }, [schools, regId])

    useEffect(() => {

        let formDataKeys = Object.keys(formData);
        let formDataValues = formDataKeys.map(key => {
            if (key !== 'parentEmail' && key !== 'permanentAddressDate' && key !== 'currentAddressDate' && key !== 'dontHavePermanentAddress' && key !== 'dontHaveCurrentAddress' && key !== 'permanentAddress') {
                return formData[key];
            }
        });

        if (!isFormValid) {
            if (formDataValues.every(x => x !== null && x !== '')) {
                if (validateWishes(formData)) {
                    if (roles.includes(user.role)) {
                        if (formData.wishes.every(x => x.sedGroup) || (autoTimeLived == 1 && user.role == 'Director')) {
                            toggleFormToValid();
                            setErrors({});
                        }
                    } else {
                        toggleFormToValid();
                        setErrors({});
                        // console.log('VALID ');
                    }
                }
            }

        }

        if (formDataValues.every(x => x == null || x == '')) {
            toggleFormToInvalid()
        }
       
        if (formData.wishes.some(x => !x.sedGroup) && autoTimeLived == 0) {
            toggleFormToInvalid()
        }

        if (formData.wishes.some(x => !x.sedGroup) && autoTimeLived == 1 && addressResidence.length == 0) {
            toggleFormToInvalid()
        }

        if (formData.twins.length > 0 && Object.values(formData.twins).some(x => x.twinEgn == '' || x.twinName == '')) {
            toggleFormToInvalid();
        }

        handleErrorLnch();

        //console.log('validaciqta ', isFormValid)

    }, [formData])

    useEffect(() => {
        setFormData(state => ({
            ...state,
            commonAdvantages: commonAdvantages.reduce((acc, x) => {
                acc[x.code] = false;
                return acc;
            }, {}),
        }))
    }, [commonAdvantages])

    useEffect(() => {
        setFormData(prevState => {
            const newState = { ...prevState };
            const firstWish = { ...newState.wishes[0] };

            const advantagesMap = advantages.reduce((acc, x) => {
                if (x.code === 'K100') {
                    acc['K100_NAME'] = '';
                    acc['K100_EGN'] = '';
                    acc['K100_IsEgn'] = true;
                } else if (x.code === 'K200') {
                    acc['K200_NAME'] = '';
                    acc['K200_EGN'] = '';
                    acc['K200_IsEgn'] = true;
                } else {
                    acc[x.code] = false;
                }
                return acc;
            }, {});

            newState.wishes[0] = {
                ...firstWish,
                ...advantagesMap,
            };

            return newState;
        });
    }, [advantages])

    useEffect(() => {
        if (addressResidence.length > 0 && user.role == 'Director' && dirDisableChildData == 1 && autoTimeLived == 1) {
            setFormData(prevState => ({
                ...prevState,
                wishes: prevState.wishes.map(({ sedGroup, ...rest }) => ({
                    ...rest
                }))
            }));
        }
    }, [addressResidence])

    const cleanSiblingInputFields = (e, i, advCode) => {
        setFormData(state => {
            let wishes = [...state.wishes];

            wishes[i][`${advCode}_EGN`] = '';
            wishes[i][`${advCode}_NAME`] = '';

            return { ...state, wishes };
        })
    }

    const handleErrorLnch = () => {
        if ((formData.childIsEgn == '0' && validateLnchYearsFromSelectedDate(formData.childLnchDate, priemYear)) || formData.childIsEgn == '1') {
            setErrors(state => ({
                ...state,
                childLnchDate: ''
            }))
        } else {

            setErrors(state => ({ ...state, childLnchDate: 'Възрастта на детето трябва да бъде между 6 и 8 години!' }))
            toggleFormToInvalid();
        }

        if (formData.twins.length > 0) {
            formData.twins.forEach(x => {
                if ((x.twinIsEgn == '0' && validateLnchYearsFromSelectedDate(x.twinLncDate, priemYear)) || x.twinIsEgn == '1') {
                    setErrors(state => ({
                        ...state,
                        [x.twinNumber]: ''
                    }))
                } else {
                    setErrors(state => ({ ...state, childLnchDate: 'Възрастта на близнака трябва да бъде между 6 и 8 години!' }))
                    toggleFormToInvalid();
                }
            })
        }
    }

    const commonAdvatagesChangeHandler = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        setFormData((prevState) => {
            const commonAdvantages = { ...prevState.commonAdvantages };
            commonAdvantages[fieldName] = e.checked;

            return { ...prevState, commonAdvantages };
        });
    }

    const handleChange = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (i !== undefined && fieldName.includes('twin')) {
            setFormData((prevState) => {
                const twins = [...prevState.twins];

                if ((fieldName.includes('Name') && cyrillicRegex.test(fieldValue) || fieldValue == '')) {
                    twins[i][fieldName] = fieldValue.toUpperCase();
                } else if (fieldName.includes('IsEgn')) {
                    setErrors(state => ({ ...state, [`${i}twinEgn`]: '' }))
                    twins[i][fieldName] = fieldValue;
                } else if (fieldName == 'twinLncDate') {
                    twins[i][fieldName] = fieldValue;
                } else if (!fieldName.includes('Name')) {
                    twins[i][fieldName] = fieldValue.trim();
                }

                return { ...prevState, twins };

            });
        } else if (fieldName.includes('Name') || fieldName.includes('NAME')) {
            if (cyrillicRegex.test(fieldValue) || fieldValue == '') {
                setFormData({
                    ...formData,
                    [fieldName]: fieldValue.toUpperCase(),
                });
            }
        } else if (fieldName.includes('IsEgn')) {
            fieldName == 'parentIsEgn' ? setErrors(state => ({ ...state, parentEgn: '' })) : setErrors(state => ({ ...state, childEgn: '' }))
            setFormData(state => ({
                ...state,
                [fieldName]: fieldValue
            }))
        } else if (fieldName == 'permanentAddress' || fieldName == 'currentAddress') {
            if (cyrillicAddressesRegex.test(fieldValue) || fieldValue == '') {
                setFormData({
                    ...formData,
                    [fieldName]: fieldValue.toUpperCase(),
                });
            }
        } else if (fieldName == 'parentPhone' || fieldName == 'parentEgn' || fieldName == 'childEgn') {
            if (phoneRegex.test(fieldValue) || fieldValue == '') {
                setFormData(state => ({ ...state, [fieldName]: fieldValue }))
            }

            return
        } else if (fieldName == 'dontHavePermanentAddress' || fieldName == 'dontHaveCurrentAddress') {
            setFormData(state => {
                let newState = { ...state };

                if (fieldName == 'dontHavePermanentAddress') {
                    newState.permanentAddressDate = null;
                } else if (fieldName == 'dontHaveCurrentAddress') {
                    newState.currentAddressDate = null;
                }

                newState[fieldName] = e.checked;

                return newState;
            })
        } else if (fieldName == 'childLnchDate' || fieldName == 'permanentAddressDate' || fieldName == 'currentAddressDate') {
            setFormData(state => ({
                ...state,
                [fieldName]: fieldValue
            }))
        } else {
            setFormData(state => ({
                ...state,
                [fieldName]: fieldValue.trim()
            }))
        }
    }

    const onBlurValidate = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (fieldName == 'parentEgn' && formData.parentIsEgn == 1) {
            if (!EgnValid(fieldValue)) {
                setErrors(state => ({ ...state, [fieldName]: 'Въведете валидно ЕГН !' }))
                toggleFormToInvalid();
            } else {
                setErrors(state => ({ ...state, [fieldName]: null }))
            }
        } else if (fieldName == 'childEgn' && formData.childIsEgn == 1) {
            if (!EgnValid(fieldValue)) {
                setErrors(state => ({ ...state, [fieldName]: 'Въведете валидно ЕГН !' }))
                toggleFormToInvalid();
            } else {
                setErrors(state => ({ ...state, [fieldName]: null }))
            }
        }

    }

    const onBlurTwinHandler = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        let twinValidationError = validateTwin(formData, fieldValue, i);
        if (fieldName == 'twinEgn' && formData.twins[i].twinIsEgn == 1) {

            if (!EgnValid(fieldValue)) {
                setErrors(state => ({ ...state, [`${i}${fieldName}`]: 'Въведете валидно ЕГН !' }))
                toggleFormToInvalid();
                return
            } else if (twinValidationError) {
                setErrors(state => ({ ...state, [`${i}${fieldName}`]: twinValidationError }))
                toggleFormToInvalid();
                return
            } else {
                setErrors(state => ({ ...state, [`${i}${fieldName}`]: null }))
            }
        }

        let dublicatedNamesError = validateDublicateChildrenNames(formData)

        if (twinValidationError) {
            setErrors(state => ({ ...state, [`${i}${fieldName}`]: twinValidationError }))
            toggleFormToInvalid();
        } else if (fieldName == 'twinName' && dublicatedNamesError) {
            setErrors(state => ({ ...state, [`${i}${fieldName}`]: dublicatedNamesError }))
            toggleFormToInvalid();
            return
        } else {
            setErrors(state => ({ ...state, [`${i}${fieldName}`]: null }))
        }
    }

    const onBlurWishHandler = (e, i, advCode) => {
        if (e.target.name == `${advCode}_EGN`) {
            if (!validateSiblingEGN(e, i, advCode, formData)
            ) {
                toggleFormToInvalid();
            }
        }

        if (formData.wishes[i][`${advCode}_EGN`] && formData.wishes[i][`${advCode}_NAME`]) {
            validateSibling(formData.wishes[i][`${advCode}_EGN`], formData.wishes[i][`${advCode}_NAME`], advCode, formData.wishes[i].school.id, i);
        }
    }

    const setAutoSedGroup = (i, wish) => {
        if (!siblingIsValid[`${i}K200Error`]
            && wish[`K200_NAME`]
            && wish[`K200_EGN`]
            && wish[`K200_NAME`].length > 0
            && wish[`K200_EGN`].length == 10
        ) {
            if (!formData.wishes[i].sedGroup || formData.wishes[i].sedGroup.code != 'K210') {
                setFormData(prevState => {
                    let wishes = [...prevState.wishes];

                    wishes[i].sedGroup = sedentaryGroups.find(x => x.code == 'K210');

                    return { ...prevState, wishes };
                })

            }

            return true;

        }

        //if (formData.wishes[i].sedGroup) {
        //    setFormData(prevState => {
        //        let wishes = [...prevState.wishes];

        //        wishes[i].sedGroup = null;

        //        return { ...prevState, wishes };
        //    })

        //}

        return false;
    }

    const wishChangeHandler = (e, i, advCode) => {
        debugger
        let fullFieldName = e.target.name;
        let [advName, prop] = e.target.name.split('_');
        let fieldValue = e.target.value;
        let isCheckbox = e.target.type == 'checkbox';

        setFormData((prevState) => {
            let wishes = [...prevState.wishes];

            if (advName == 'school') {
                let isAlreadySelected = false;

                formData.wishes.forEach(x => {
                    if (x.school.id == fieldValue.id) {
                        isAlreadySelected = true;
                        Swal.fire({
                            title: 'Внимание!',
                            text: 'Училището вече е избрано като желание.',
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })

                        return;
                    }
                })

                if (isAlreadySelected) {
                    wishes[i][e.target.name] = '';
                    return { ...prevState, wishes };
                }

                for (var key in wishes[i]) {
                    if (key.includes('IsEgn')) {
                        wishes[i][key] = '1';
                    } else if (key.includes('EGN')) {
                        wishes[i][key] = '';
                    } else if (key.includes('NAME')) {
                        wishes[i][key] = '';
                    }
                }

                if (autoTimeLived == 0 || user.role == 'Municipality' || user.role == 'Admin' || user.role == 'SuperAdmin') {
                    wishes[i].sedGroup = null;
                    toggleFormToInvalid();
                }
            }

            if (fullFieldName.includes('NAME') && cyrillicRegex.test(fieldValue) || fieldValue == '') {
                wishes[i][e.target.name] = fieldValue.toUpperCase();
            } else if (fullFieldName.includes('NAME') && !cyrillicRegex.test(fieldValue)) {
                return { ...prevState, wishes };
            } else if (fullFieldName.includes('IsEgn')) {
                removeError(e, i, advCode)
                wishes[i][e.target.name] = fieldValue;
            } else if (fullFieldName.includes('EGN')) {
                if (phoneRegex.test(fieldValue) || fieldValue == '') {
                    wishes[i][e.target.name] = fieldValue.trim();
                }
            } else {
                wishes[i][e.target.name] = isCheckbox ? e.target.checked : fieldValue;

                if (parameters.municipality.obshtina_name == 'БОТЕВГРАД' && e.target.name == 'sedGroup' && fieldValue.code == 'K240') {
                    wishes[i]['K120'] = false;
                }
            }

            return { ...prevState, wishes };
        });

        if (isCheckbox && advName == 'K50' && e.target.checked == true) {
            isChildHavePreparatoryGroup(formData.childEgn, formData.childName, formData.wishes[i].school.id, i);
        } else if (isCheckbox && advName == 'K50' && e.target.checked == false) {
            cleanChildHavePreparatoryGroupState(i);
        }
    }

    const addTwin = (e) => {
        e.preventDefault();

        let newState = { ...formData }
        let twinNumber = newState.twins.length + 1;

        if (twinNumber > 3) {
            Swal.fire({
                title: 'Внимание!',
                text: 'Не може да добавяте повече от три близнака',
                icon: 'warning',
                confirmButtonText: 'ОК'
            })

            return
        }

        newState.twins.push({ twinNumber, twinIsEgn: '1', twinEgn: '', twinName: '' });

        toggleFormToInvalid();

        setFormData(newState);
    }

    const removeTwin = (e) => {
        e.preventDefault();

        let newState = { ...formData }

        newState.twins.pop();

        toggleFormToInvalid();

        setFormData(newState);
    }

    const addWish = (e) => {
        e.preventDefault();

        let newState = { ...formData }

        if (newState.wishes.length >= maxDesires) {
            Swal.fire({
                title: 'Внимание!',
                text: 'Достигнали сте максималния брой желания.',
                icon: 'warning',
                confirmButtonText: 'ОК'
            })

            return
        }

        const advantagesMap = advantages.reduce((acc, x) => {
            if (x.code === 'K100') {
                acc['K100_NAME'] = '';
                acc['K100_EGN'] = '';
                acc['K100_IsEgn'] = true;
            } else if (x.code === 'K200') {
                acc['K200_NAME'] = '';
                acc['K200_EGN'] = '';
                acc['K200_IsEgn'] = true;
            } else {
                acc[x.code] = false;
            }
            return acc;
        }, {});

        newState.wishes.push({ id: '', school: '', ...advantagesMap });

        toggleFormToInvalid();

        setFormData(newState);
    }

    const removeWish = (e, i) => {
        e.preventDefault();
        Swal.fire({
            title: "Внимание !",
            text: `Сигурни ли сте, че искате да изтриете това желание?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Не",
            confirmButtonText: "Да"
        }).then((result) => {
            if (result.isConfirmed) {
                let newState = { ...formData }

                newState.wishes.pop();

                toggleFormToInvalid();

                setFormData(newState);
            }
        });
    }

    const isTwinsInValid = () => {
        if (formData.twins.length == 0) {
            return false;
        } else if (formData.twins.length > 0 && formData.twins.some(x => x.twinEgn == '' && x.twinName == '')) {
            return true
        } else {
            return false
        }
    }

    const scrollToComponent = (ref) => {
        const scrollToRef = ref.current;
        if (scrollToRef) {
            const elementOffset = scrollToRef.getBoundingClientRect().top;
            const offset = elementOffset - 100;

            const duration = 500;

            const startingY = window.pageYOffset;
            const diff = offset;
            let start;

            window.requestAnimationFrame(function step(timestamp) {
                if (!start) start = timestamp;
                const time = timestamp - start;
                const percent = Math.min(time / duration, 1);

                window.scrollTo(0, startingY + diff * percent + 70);

                if (time < duration) {
                    window.requestAnimationFrame(step);
                }
            });
        }
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        let body = MunicipalityRegisterBodyFormat(formData);

        if (user.role == 'Municipality' || user.role == 'SuperAdmin' || user.role == 'Admin') {
            editMunicipalityApplication(regId, body)
                .then((data) => {
                    if (data.status == 400) {
                        Swal.fire({
                            title: 'Внимание!',
                            text: data.message,
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })
                    } else {
                        setIsEditSuccessfully(true);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    Swal.fire({
                        title: 'Внимание!',
                        text: err.message,
                        icon: 'error',
                        confirmButtonText: 'ОК'
                    })
                    setLoading(false);
                })
        } else {
            editFreeAddressTextApplication(regId, body)
                .then((data) => {
                    if (data.status == 400) {
                        Swal.fire({
                            title: 'Внимание!',
                            text: data.message,
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })
                    } else {
                        setIsEditSuccessfully(true);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    Swal.fire({
                        title: 'Внимание!',
                        text: err.message,
                        icon: 'error',
                        confirmButtonText: 'ОК'
                    })
                    setLoading(false);
                })
        }
       
    }

    const getApplicationPDF = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            let response = '';
            const saltRounds = 12;
            const hashedParentEgn = await bcrypt.hash(formData.parentEgn, saltRounds);
            let downloadUrl = await fileService.getApplicationPDF({ regId: regId, hashedParentEgn: hashedParentEgn })

            if (downloadUrl) {
                window.open(downloadUrl, '_blank');
            }

            setLoading(false);
        } catch (error) {
            console.error('Error fetching PDF:', error);
            Swal.fire({
                title: 'Внимание!',
                text: error.message,
                icon: 'error',
                confirmButtonText: 'ОК'
            })
        }
    }

    return (
        <div className="d-flex container-mob gap-5">
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
            {regId && !isEditSuccessfully ?
                <>
                    <div className="form-navigator position-sticky nav-mobile" style={{ top: '50px' }}>
                        <button onClick={() => scrollToComponent(parentDataRef)}>Данни за родител</button>
                        <button onClick={() => scrollToComponent(childrenDataRef)}>Данни за дете</button>
                        <button onClick={() => scrollToComponent(commonAdvantagesRef)}>Общи критерии</button>
                        <button onClick={() => scrollToComponent(wishesRef)}>Желания</button>
                    </div>
                    <div className="w-80 form-body-mob">
                        <div className="title_entr use-font">Редакция на заявление {regId}</div>

                        <div className="reg_cont">
                            {/*<a href="/#" onClick={getApplicationPDF}>натиснете тук mun</a>*/}
                            <form className="form w-100 d-flex flex-row justify-content-between align-items-center flex-wrap" action="parent_ack" method="post">
                                <ParentData
                                    ref={parentDataRef}
                                    id='parentData'
                                    formData={formData}
                                    handleChange={handleChange}
                                    onBlurValidate={onBlurValidate}
                                    errors={errors}
                                    isEdit={true}
                                    isMunicipality={true}
                                />
                                <ChildrenData
                                    ref={childrenDataRef}
                                    id='childrenData'
                                    formData={formData}
                                    handleChange={handleChange}
                                    addTwin={addTwin}
                                    removeTwin={removeTwin}
                                    onBlurTwins={onBlurTwinHandler}
                                    onBlurValidate={onBlurValidate}
                                    errors={errors}
                                    isEdit={true}
                                    isMunicipality={true}
                                />
                                <CommonAdvantages
                                    ref={commonAdvantagesRef}
                                    id='commonAdvantages'
                                    formData={formData}
                                    handleChange={commonAdvatagesChangeHandler}
                                />
                                < Wishes
                                    ref={wishesRef}
                                    id='wishes'
                                    formData={formData}
                                    wishChangeHandler={wishChangeHandler}
                                    addWish={addWish}
                                    removeWish={removeWish}
                                    isEdit={true}
                                    cleanSiblingInputFields={cleanSiblingInputFields}
                                    isMunicipality={true}
                                    onBlurWishHandler={onBlurWishHandler}
                                    setAutoSedGroup={setAutoSedGroup}
                                />
                                <button
                                    className="btn but_add mb-3 mt-3"
                                    disabled={!isFormValid || Object.values(dontHaveCompletedGroup).some(x => x !== '') || Object.values(siblingIsValid).some(x => x.length > 0) || isTwinsInValid()}
                                    onClick={onSubmit}
                                >
                                    Завърши редакцията
                                </button>
                            </form>
                        </div>

                    </div>
                </>
                : <>
                    <div className="children_data">
                        <div className="title_entr text-success">Редакцията на заявлението е успешна</div>
                        <div className="htext text-center">Вашият номер на редактираното заявление е <b>{regId}</b></div>
                        <p className="text-md-center">За да изтеглите вашето редактирано заявление <a href="/#" onClick={getApplicationPDF}>натиснете тук</a></p>
                    </div>
                </>
            }
        </div>
    )
}